import pictureExtension from "../constants/picture-extension";

const fileIsImage = (fileName) => {
	return pictureExtension.includes(fileName?.split(".").pop());
};

export default fileIsImage;
